import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { EmailVerificationLinkSentToast, resendEmailVerificationOptions } from '@/entities/user';

export function useResendVerificationLink() {
    const resendMutation = useMutation(
        resendEmailVerificationOptions(() => toast.success(<EmailVerificationLinkSentToast />)),
    );

    return {
        isResending: resendMutation.isPending,
        resendLink: () => resendMutation.mutate(),
    };
}
